export default __webpack_public_path__ + "static/media/inner_header@2x.f1506e95.gif";